import React, { useCallback } from "react";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../constants/assets/containers";
import styled from "styled-components";
import Button from "sushiweb/Button";
import Permission from "../Common/Permission";
import Input from "sushiweb/InputTypes/Input";
import NoFooterModal from "../Common/NoFooterModal";
import { getCityList, getBulkCities } from "../../store/actions/City";
import { getZoneList, getBulkZones } from "../../store/actions/Zone";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Textarea from "sushiweb/InputTypes/Textarea";
import {
  getPath,
  isValidated,
  isValNull,
  validateEmail,
  validateIndianPhone,
  validatePercentage,
  validateStoreId,
} from "../../utils";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import {
  getFleetCoachDetails,
  getFleetCoachList,
  saveUpdateFleetCoach,
  updateFleetCoachDocuments,
} from "../../store/actions/FleetCoachV2";
import { setStatus } from "../../store/actions/User";
import Capitalize from "lodash-es/capitalize";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import FleetCoachImageUpload from "./FleetCoachImageUpload";
import { Api } from "../../services/config/request";
import Table from "../Common/Table";

const statusOptions = ["ACTIVE", "INACTIVE"];
const isTestFCOptions = ["TRUE", "FALSE"];
const businessOptions = ["ZOMATO", "BLINKIT"];

const mandatoryFieldsToCheck = [
  "status",
  "contact",
  "lastName",
  "firstName",
  "zones",
  "isTestFleetCoach",
  "business",
];

const FleetCoachModal = (props) => {
  const {
    activeId,
    modalState,
    handleClose,
    activeFilters,
    activeFleetCoach,
    setStatus,
    nextPageCity,
    getCityList,
    getZoneList,
    saveUpdateFleetCoach,
    currentPage,
    getFleetCoachList,
    getFleetCoachDetails,
    updateFleetCoachDocuments,
    getBulkCities,
    getBulkZones,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.FLEET_COACH_V2];
  const [shouldUploadFile, setShouldUploadFile] = React.useState(false);
  const [fileUploaded, setFileUploaded] = React.useState(false);
  const [priorityFlagZones, setPriorityFlagZones] = React.useState(false);
  const [initialState, setInitialState] = React.useState({
    id: null,
    fcId: "",
    firstName: "",
    lastName: "",
    cities: [],
    zones: [],
    stores: [],
    emailId: "",
    phoneNo: "",
    status: modalState === "Filter" ? null : "ACTIVE",
    profile: "",
    profileImageKey: "",
    secondaryFcId: "",
    zoneMapping: [],
    isTestFleetCoach: "FALSE",
    alternatePhoneNo: "",
    business: "ZOMATO",
  });

  React.useEffect(() => {
    if (activeId) {
      getFleetCoachDetails(activeId);
    }
  }, [activeId, modalState]);

  React.useEffect(() => {
    if (activeFleetCoach) {
      setInitialStateObjectValues(activeFleetCoach);
    }
  }, [activeFleetCoach]);

  React.useEffect(() => {
    if (activeFilters) {
      setInitialStateObjectValues(activeFilters);
    }
  }, [activeFilters]);

  const setInitialStateObjectValues = (obj) => {
    if (Object.keys(obj).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((item, index) => {
        if (!isValNull(obj[item])) {
          values[item] = obj[item];
        } else {
          if (item === "zones" || item === "cities") {
            obj[item] = [];
            values[item] = [];
          }
        }
      });
      setInitialState(values);
      setPriorityFlagZones(true);
    }
  };

  function isArray(myArray) {
    return myArray.constructor.toString().indexOf("Array") > -1;
  }

  function containsElement(zoneMapping, key) {
    let flag = false;
    for (let i = 0; i < zoneMapping.length; i++) {
      if (key == zoneMapping[i].zone_id) {
        flag = true;
      }
    }
    return flag;
  }
  function getPercentage(zoneMapping, key) {
    for (let i = 0; i < zoneMapping.length; i++) {
      if (key == zoneMapping[i].zone_id) {
        return zoneMapping[i].percentage;
      }
    }
    return null;
  }

  const handleChange = (key, value, extraParams, val) => {
    const values = { ...initialState };
    values[key] = value;
    if (key === "cities") {
      setPriorityFlagZones(true);
    }
    if (key === "stores") {
      if (value) {
        value = value.split(",");
        const numberValue = [];
        for (let i = 0; i < value.length; i++) {
          if (!validateStoreId(value[i])) {
            setStatus({
              type: "error",
              message: "Invalid StoreId, Must be a number",
            });
          }
          numberValue.push(value[i]);
        }
        values["stores"] = numberValue;
      }
    }
    if (key === "zones") {
      if (val) {
        if (isArray(val)) {
          if (val.length > 0 && val[0].hasOwnProperty("zone_name")) {
            let tmp = [];
            for (let i = 0; i < val.length; i++) {
              if (containsElement(initialState.zoneMapping, val[i].id)) {
                tmp.push({
                  zone_id: val[i].id,
                  zone_name: val[i].zone_name,
                  percentage: getPercentage(
                    initialState.zoneMapping,
                    val[i].id
                  ),
                });
              } else {
                tmp.push({
                  zone_id: val[i].id,
                  zone_name: val[i].zone_name,
                  percentage: null,
                });
              }
            }
            values["zoneMapping"] = tmp;
          }
        }
      }
    }
    if (key === "business" && value === "ZOMATO") {
      values["stores"] = [];
    }
    setInitialState(values);
  };

  const handleZoneMappingChange = (key, value, zone_id, index) => {
    const values = { ...initialState };
    values[key][index]["percentage"] = value;
    setInitialState(values);
  };

  const handleClearFilters = () => {
    getFleetCoachList(1, {}).then((res) => {
      if (res) {
        handleClose();
      }
    });
  };

  const getRequiredButtonPerms = () => {
    if (modalState === "Edit" || modalState === "Add") {
      return [allActions.CREATE];
    }
    return undefined;
  };

  const onUploadSuccess = (sign_id) => {
    setShouldUploadFile(false);
    handleClose();
    updateFleetCoachDocuments(initialState.id, { key: sign_id }).then(
      (res) => {}
    );
  };
  const handleDirectUploadFailure = (err) => {
    setStatus({
      type: "error",
      message: err,
    });
    if (modalState === "Add") {
      setStatus({
        type: "error",
        message: "Retry image upload by Editing Fleet Coach",
      });
      handleClose();
    }
  };

  const handleSubmit = () => {
    if (!checkEmailPercentageAndPhoneValidation()) {
      return;
    }
    if (!checkStoreValidation()) {
      return;
    }
    if (modalState === "Filter") {
      if (initialState.phoneNo) {
        initialState.phoneNo = Number(initialState.phoneNo);
      }
      getFleetCoachList(currentPage, initialState).then((res) => {
        if (res) {
          handleClose();
        }
      });
    } else {
      let validatedState = isValidated(initialState, mandatoryFieldsToCheck);
      if (validatedState === "validated") {
        // initialState.phoneNo = Number(initialState.phoneNo);
        saveUpdateFleetCoach(modalState, initialState).then((fleetDetails) => {
          if (fleetDetails) {
            handleChange("fcId", getPath(fleetDetails, "fleet_coach.fcId", 0));
            handleChange("id", getPath(fleetDetails, "fleet_coach.id", 0));
            setShouldUploadFile(true);
            getFleetCoachList(currentPage, activeFilters).then((fleetList) => {
              // setShouldUploadFile(false);
            });
            if (!fileUploaded) {
              handleClose();
            }
          }
        });
      } else {
        setStatus({
          type: "error",
          message: Capitalize(validatedState),
        });
      }
    }
  };

  const checkStoreValidation = () => {
    if (initialState.stores.length > 0) {
      for (let i = 0; i < initialState.stores.length; i++) {
        if (!validateStoreId(initialState.stores[i])) {
          setStatus({
            type: "error",
            message: "Invalid StoreIds, All storeIds must be a number",
          });
          return false;
        }
      }
    }
    return true;
  };

  const checkEmailPercentageAndPhoneValidation = () => {
    if (initialState.emailId && !validateEmail(initialState.emailId)) {
      setStatus({
        type: "error",
        message: "Enter a Valid Email",
      });
      return false;
    }
    if (initialState.phoneNo && !validateIndianPhone(initialState.phoneNo)) {
      setStatus({
        type: "error",
        message: "Enter a valid phone number in format: ((+91|0)9876543210)",
      });
      return false;
    }
    if (initialState.zoneMapping) {
      for (let i = 0; i < initialState.zoneMapping.length; i++) {
        if (
          initialState.zoneMapping[i].percentage &&
          !validatePercentage(initialState.zoneMapping[i].percentage)
        ) {
          setStatus({
            type: "error",
            message: "Enter a valid percentage between 0-100.",
          });
          return false;
        }
      }
    }
    return true;
  };

  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" ? (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        ) : (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClose}
            className="sushi-btn"
          >
            Cancel
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitFleetCoachButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };
  const getFieldValue = (activeObj, key, index) => {
    if (typeof index === "number") {
      switch (key) {
        case "zone%": {
          return (
            <Input
              value={initialState.zoneMapping[index].percentage}
              type="number"
              data-testid="zoneMapping"
              id="sushi-input"
              onChange={(e) =>
                handleZoneMappingChange("zoneMapping", e, activeObj.id, index)
              }
              errorMsg={
                !initialState.zoneMapping[index].percentage ||
                validatePercentage(initialState.zoneMapping[index].percentage)
                  ? ""
                  : "Enter a valid percentage 0-100 "
              }
              label="Percentage"
            />
          );
        }
        default: {
          return activeObj[key] ? activeObj[key] : "-";
        }
      }
    }
  };
  console.log("stores: ", initialState.stores);

  const getDirectUploadPath = useCallback(() => {
    return (
      Api.url() +
      `/logistics-support/fleet-coach/${initialState.id}/documents/profile`
    );
  }, [initialState]);
  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Fleet Coach`}
      handleClose={handleClose}
      id="FleetCoachModal"
      modalButtons={getModalButtons()}
    >
      {modalState !== "Filter" && (
        <FleetCoachImageUpload
          setFileUploaded={setFileUploaded}
          directUploadPath={getDirectUploadPath()}
          shouldUploadFile={shouldUploadFile}
          setStatus={setStatus}
          onUploadSuccess={onUploadSuccess}
          handleDirectUploadFailure={handleDirectUploadFailure}
          imageUrl={initialState.profile}
        />
      )}
      {modalState === "Filter" && (
        <Input
          value={initialState.fcId}
          data-testid="fcIdFleetCoach"
          id="sushi-input"
          onChange={(e) => handleChange("fcId", e)}
          label="FC Id"
        />
      )}
      {modalState !== "Filter" && (
        <FlexContainer>
          <Input
            value={initialState.firstName}
            data-testid="firstNameFleetCoach"
            id="sushi-input"
            onChange={(e) => handleChange("firstName", e)}
            label="First Name"
            fullWidth={true}
          />
          <Input
            value={initialState.lastName}
            data-testid="lastNameFleetCoach"
            id="sushi-input"
            onChange={(e) => handleChange("lastName", e)}
            label="Last Name"
            fullWidth={true}
          />
        </FlexContainer>
      )}
      <Input
        value={initialState.emailId}
        data-testid="emailFleetCoach"
        id="sushi-input"
        onChange={(e) => handleChange("emailId", e)}
        label="Email"
        type={"email"}
        errorMsg={
          !initialState.emailId || validateEmail(initialState.emailId)
            ? ""
            : "Enter a valid email (abc.xyz@domain.com)"
        }
      />
      <Input
        value={initialState.phoneNo}
        data-testid="contactFleetCoach"
        id="sushi-input"
        onChange={(e) => handleChange("phoneNo", e)}
        label="Phone Number"
        errorMsg={
          !initialState.phoneNo || validateIndianPhone(initialState.phoneNo)
            ? ""
            : "Enter a valid phone number in format: ((+91|0)9876543210)"
        }
      />
      <Input
        value={initialState.alternatePhoneNo}
        data-testid="alternateContactFleetCoach"
        id="sushi-input"
        onChange={(e) => handleChange("alternatePhoneNo", e)}
        label="Alternate Phone Number"
        errorMsg={
          !initialState.alternatePhoneNo ||
          validateIndianPhone(initialState.alternatePhoneNo)
            ? ""
            : "Enter a valid phone number in format: ((+91|0)9876543210)"
        }
      />

      {modalState !== "Filter" && (
        <Input
          value={initialState.secondaryFcId}
          data-testid="secondaryFcIdFleetCoach"
          id="sushi-input"
          onChange={(e) => handleChange("secondaryFcId", e)}
          label="Secondary FC Id"
        />
      )}
      <InfiniteScrollDropdown
        id="multipleCities"
        appliedFilters={{}}
        priorityFlag={true}
        getActiveList={getCityList}
        nextPage={nextPageCity}
        resKey="cities"
        modalState={modalState}
        keyName="cities"
        labelKey="city_name"
        getDataLabelKey="city.city_name"
        keyTypeToSet="id"
        label="Cities"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        activeFilters={activeFilters}
        activeElement={activeFleetCoach}
        getActiveItemById={getBulkCities}
        multiple
      />
      <InfiniteScrollDropdown
        id="multipleZones"
        priorityFlag={priorityFlagZones}
        setPriorityFlag={setPriorityFlagZones}
        appliedFilters={
          initialState.cities ? { city_id: initialState.cities } : {}
        }
        getActiveList={getZoneList}
        resKey="zones"
        modalState={modalState}
        keyName="zones"
        labelKey="zone_name"
        getDataLabelKey="zone.zone_name"
        keyTypeToSet="id"
        label="Zones"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        activeFilters={activeFilters}
        activeElement={activeFleetCoach}
        getActiveItemById={getBulkZones}
        multiple
      />
      {initialState.business === "BLINKIT" && (
        <>
          <TextAreaWrapper>
            <Textarea
              fullWidth={true}
              rows={initialState.stores.length / 5 + 1}
              label="Stores"
              onChange={(e) => handleChange("stores", e)}
              value={initialState.stores}
            />
          </TextAreaWrapper>
        </>
      )}
      {modalState !== "Filter" && initialState.zoneMapping.length > 0 && (
        <FleetCoachZonePercentageMapping>
          <Table
            list={initialState.zoneMapping}
            fields={[
              {
                heading: "Zone Name",
                key: "zone_name",
              },
              {
                heading: "Driver Percentage Zone mapping",
                key: "zone%",
              },
            ]}
            getFieldValue={getFieldValue}
          />
        </FleetCoachZonePercentageMapping>
      )}
      <PaginatedReactDropdown
        options={statusOptions}
        data-testid="fleetCoachStatus"
        value={initialState.status}
        labelWidth="10%"
        handleChange={handleChange}
        keyToChange="status"
        placeholder="Status"
        showCross={true}
        id="fleetCoachStatus"
      />
      <Permission requiredPerms={[allActions.ADMIN]}>
        <PaginatedReactDropdown
          options={isTestFCOptions}
          data-testid="testFleetCoach"
          value={initialState.isTestFleetCoach}
          labelWidth="10%"
          handleChange={handleChange}
          keyToChange="isTestFleetCoach"
          placeholder="Test FC"
          showCross={true}
          id="testFleetCoach"
        />
      </Permission>
      <PaginatedReactDropdown
        options={businessOptions}
        data-testid="business"
        value={initialState.business}
        labelWidth="10%"
        handleChange={handleChange}
        keyToChange="business"
        placeholder="Business"
        showCross={true}
        id="business"
      />
    </NoFooterModal>
  );
};

const FleetCoachZonePercentageMapping = styled.div`
  margin-bottom: 20px;
`;

const mapStateToProps = (state) => {
  const { City, FleetCoach } = state;
  return {
    cityList: City.cityList,
    nextPageCity: City.nextPage,
    activeFleetCoach: FleetCoach.activeFleetCoach,
    activeFilters: FleetCoach.activeFilters,
    currentPage: FleetCoach.currentPage,
  };
};
const TextAreaWrapper = styled.section`
  margin-bottom: 20px;
`;

const mapDispatchToProps = (dispatch) => {
  return {
    getBulkCities: bindActionCreators(getBulkCities, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
    getZoneList: bindActionCreators(getZoneList, dispatch),
    getBulkZones: bindActionCreators(getBulkZones, dispatch),
    saveUpdateFleetCoach: bindActionCreators(saveUpdateFleetCoach, dispatch),
    getFleetCoachList: bindActionCreators(getFleetCoachList, dispatch),
    getFleetCoachDetails: bindActionCreators(getFleetCoachDetails, dispatch),
    updateFleetCoachDocuments: bindActionCreators(
      updateFleetCoachDocuments,
      dispatch
    ),
    setStatus: bindActionCreators(setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FleetCoachModal);
